import React, { FC } from 'react';
import { Icon, IconProps } from './Icon';

export const ArrowLeft: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path d="M20 38.1406L23 35.1406L13.8594 26L42 26L42 22L13.8594 22L23 12.8594L20 9.85937L5.85938 24L20 38.1406Z" fill="currentColor"/>
  </Icon>
);
